<div class="bg-section d-flex py-30 align-items-center justify-content-center">
  <div class="new-password-wrap text-center px-20 py-30" *ngIf="errorMessage">
    <div class="sucess-img-holder mb-20">
      <div class="col-xs-4">
        <i class="fa fa-exclamation-triangle fa-5x"></i>
      </div>
    </div>
    <h3 class="mb-20">Failed!</h3>
    <p class="mb-20 sucess-message">{{ errorMessage }}</p>
  </div>

  <div class="new-password-wrap text-center px-20 py-30" *ngIf="!formShow && !errorMessage">
    <div class="sucess-img-holder mb-20">
      <img src="/img/sucess.svg" alt="sucess-icon" />
    </div>
    <h3 class="mb-20">Success!</h3>
    <p class="mb-20 sucess-message">Your password has been successfuly changed.</p>
    <a [routerLink]="['/login']" class="btn btn-primary">Start testing</a>
  </div>

  <div class="new-password-wrap px-20 py-30" *ngIf="formShow">
    <div class="logo-holder mb-20 text-center">
      <a href="#" class="logo"><img src="/img/logo.png" alt="Telq" /></a>
    </div>
    <h1 class="display-5 mb-20 text-center">Create New Password</h1>
    <form (ngSubmit)="onSubmit()" [formGroup]="form">
      <div class="form-group mb-15 position-relative">
        <label for="password" class="form-label">New Password</label> <span *ngIf="isPasswordLoading" class="fa fa-spinner fa-spin loading-icon mx-0_5"></span>
        <input type="password" [(ngModel)]="newPassword" formControlName="newPassword" [attr.type]="passwordType" class="form-control"
          placeholder="Create New Password" />
        <span class="icon position-absolute" (click)="togglePasswordType()"
          [ngClass]="{ 'icon-show': !isPasswordType(), 'icon-hide': isPasswordType() }"></span>
        <ng-container *ngFor="let error of passwordValidateErrors">
          <span class="password-error text-error-r2">
            {{error}}
          </span><br>
        </ng-container>
        <input-errors [control]="form.controls.newPassword" [service]="validationService"></input-errors>
      </div>
      <span class="note d-block mb-20">
        Use 8 or more characters with a mix of letters, numbers & special characters like
        !&#64;#$%^&*()_+\-=[];':"|,.<>/?
      </span>
      <div class="form-group mb-20 position-relative">
        <label for="#" class="form-label">Repeat New Password</label>
        <input type="password" [(ngModel)]="repeatNewPassword" formControlName="repeatNewPassword" [attr.type]="passwordType" class="form-control"
          placeholder="Repeat New Password" />
        <span class="icon position-absolute" (click)="togglePasswordType()"
          [ngClass]="{ 'icon-show': !isPasswordType(), 'icon-hide': isPasswordType() }"></span>
        <input-errors [control]="form.controls.repeatNewPassword" [service]="validationService"></input-errors>
      </div>
      <div class="btn-holder text-center">
        <button class="btn btn-primary text-center w-full" [disabled]="!form.valid || this.passwordValidateErrors?.length > 0 || loading">
          <ng-container *ngIf="!loading">Save</ng-container>
          <i *ngIf="loading" class="icon icon-wait spin"></i>
        </button>
      </div>
    </form>
  </div>
</div>
